import { Context, useContext } from 'react';

export const useGetContext = <T>(contextToUse: Context<T | undefined>, contextName: string): T => {
  const context = useContext<T | undefined>(contextToUse);
  if (!context) {
    throw new Error(`${contextName} is required`);
  }
  return context;
};
